import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pencil",
  "use": "pencil-usage",
  "viewBox": "0 0 29 29",
  "content": "<symbol viewBox=\"0 0 29 29\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pencil\">\n<circle cx=\"14.5\" cy=\"14.5\" r=\"14.5\" fill=\"currentColor\" />\n<path d=\"M15.5179 9.73147L19.2684 13.4821L11.1243 21.6265L7.78047 21.9956C7.33283 22.0451 6.95462 21.6666 7.00442 21.219L7.37648 17.8726L15.5179 9.73147ZM21.588 9.17306L19.827 7.41199C19.2777 6.86267 18.3868 6.86267 17.8375 7.41199L16.1808 9.06876L19.9313 12.8194L21.588 11.1626C22.1373 10.613 22.1373 9.72238 21.588 9.17306Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol